import React, { createContext, Context } from "react";
import { CMSPermission } from "../../../laco-common/base/models/user";

export type ICMSRoleContext = {
	userRoles: string[];
	permissions: string[];
	hasPermission: (permission: CMSPermission | string) => boolean;
};

const CMSRoleContext: Context<ICMSRoleContext> = createContext<ICMSRoleContext>(null);

export const withCmsRoleContext = (Component) => (props: CMSRoleContextProps & any) => (
	<CMSRoleContext.Consumer>{(context) => <Component cmsRoleContext={context} {...props} />}</CMSRoleContext.Consumer>
);
export type CMSRoleContextProps = { cmsRoleContext: ICMSRoleContext };

export default CMSRoleContext;
